import actionTypes from './actionTypes';
import { ServiceApi } from '../../api/service';

const api = new ServiceApi();

export const loadServices = () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_SERVICES_START, payload: {}});
        
        const {data} = await api.getServicesList();

        return dispatch({type: actionTypes.LOAD_SERVICES_SUCCESS, payload: {data}});

    }catch(error){
        return dispatch({type: actionTypes.LOAD_SERVICES_FAIL, payload: {error}});
    }
};